module.exports = __webpack_public_path__ + "img/white-arrow-right.a81dd939.svg";